<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.icms_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-info"></i>
            </span>
          </a>
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.icms_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.icms_vigencia.length > 0"
          >
            <span class="nav-link-in">
              Vigencias
              <i class="fa fa-calendar"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.icms_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Mensagem Legal Contribuinte</th>
                <th style="width: 50%">Mensagem Não Legal Contribuinte</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.msg_legal_contribuinte }}
                </td>
                <td>
                  {{ rowData.msg_legal_nao_contribuinte }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          role="tabpanel"
          class="tab-pane fade in"
          v-bind:id="'t2' + rowData.icms_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 18%">Data inicial da Vigência</th>
                <th style="width: 18%">Data final da Vigência</th>
                <th style="width: 18%">Aliquota Contribuinte</th>
                <th style="width: 18%">Aliquota Não Contribuinte</th>
                <th style="width: 18%">Aliquota FCP</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.icms_vigencia"
              >
                <td>
                  {{ formatDate(item.dt_vigencia_ini) }}
                </td>
                <td>
                  {{ formatDate(item.dt_vigencia_fim) }}
                </td>
                <td>
                  {{ item.aliquota_contribuinte }}
                </td>
                <td>
                  {{ item.aliquota_nao_contribuinte }}
                </td>
                <td>
                  {{ item.aliquota_pobreza }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onEditVigencia(item)"
                    v-b-tooltip
                    title="Editar"
                    v-if="getPermissionFw('icms.update')"
                    ><i class="fa fa-edit"></i
                  ></a>
                  <span v-if="getPermissionFw('icms.status')">
                    <a
                      v-if="item.status.valor == 2"
                      @click="onActivateDesactivate(1, item, true)"
                      v-b-tooltip
                      title="Ativar"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                    <a
                      v-if="item.status.valor == 1"
                      @click="onActivateDesactivate(2, item, true)"
                      v-b-tooltip
                      title="Inativar"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <IcmsVigenciaForm
        ref="icmsvigenciaform"
        :metodo="onFilterReset"
        :tabela="'icms_vigencia'"
        :rota="'icmsvigencia'"
      />
    </div>
  </div>
</template>

  <script>
import moment from "moment";
import IcmsVigenciaForm from "./IcmsVigenciaForm.vue";
export default {
  components: {
    IcmsVigenciaForm
  },
  data() {
    return {
      helpForm: new Form({
        statusRecord: [],
        params: [],
        statusRecord: [],
        status: ""
      })
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    formatDate(value, fmt = "D/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    onEditVigencia(data) {
      this.$refs.icmsvigenciaform.onEdit(data);
    },
    onActivateDesactivate(action, data, tipo) {
      console.log(data);
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push(data.icmsvig_id);
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach(obj => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.icmsvigenciaform.onActivateDesactivate(this.helpForm);
    }
  }
};
</script>
